import React from 'react'

import { TableCell } from '@mui/material'
import { TextCell } from '@abra/elements/table/cells/basics/'

import FormatUtils from '@front/squirtle/utils/format'

const Row = ({ row }) => <>
  <TableCell><TextCell value={row?.list_client_id} /></TableCell>
  <TableCell><TextCell value={row?.commercial_package.name_translated} /></TableCell>
  <TableCell><TextCell value={FormatUtils.formatDateBackToFront(row?.createdAt)} /></TableCell>
</>

export default React.memo(Row)
